import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryContants } from "../../../constant";
import { createBuyGame } from "../../../apis/game/game";

export const useCreateBuyGameMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createBuyGame,
    onSuccess: () => {
      queryClient.invalidateQueries(queryContants.GET_ME);
    },
  });
};
